import CustomButtom from "common/components/Button/Button"
import FormikInputNumber from "common/components/FormikFields/FormikInputNumber"
import WarningModal from "common/components/Modal/WarningModal"
import { Dropdown, DropdownChangeParams } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import { useState } from "react"

import {
  useCuentaContableEmpresaComisionAperturaPrestamoConcedido,
  useCuentaContableEmpresaComisionAperturaPrestamoRecibido,
} from "api/CuentaContableEmpresa.hook"
import {
  useCuentaContableCuentaComisionAperturaPrestamoConcedido,
  useCuentaContableCuentaComisionAperturaPrestamoRecibido,
} from "api/CuentaContable_Cuenta.hook"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import { PRESTAMOS_TYPE } from "common/utils/constants"
import { useTranslation } from "react-i18next"
import {
  IMPORTE_TIPO_SELECT_OPTIONS,
  SELECTOR_TIPO,
} from "../NewPrestamoForm/constants"

const NewAmortizacion = ({
  handleBlur,
  values,
  handleOpenModal,
  handleChange,
  handleSubmit,
  prestamo,
  setFieldValue,
  errors,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionAperturaPrestamoRecibidoComprasBase,
  } = useCuentaContableCuentaComisionAperturaPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasContablesComisionAperturaPrestamoRecibido,

    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionAperturaPrestamoRecibido,
  } = useCuentaContableEmpresaComisionAperturaPrestamoRecibido()

  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionAperturaPrestamoConcedidoComprasBase,
  } = useCuentaContableCuentaComisionAperturaPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasContablesComisionAperturaPrestamoConcedido,

    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionAperturaPrestamoConcedido,
  } = useCuentaContableEmpresaComisionAperturaPrestamoConcedido()

  const [showWarningModal, setShowWarningModal] = useState(false)

  const handleSetValue = (value: $TSMigrationFixMe, key: $TSMigrationFixMe) => {
    setFieldValue(key, value)
  }

  const handleSelectCtaContable = (newCuentaContable: DropdownChangeParams) =>
    handleSetValue(newCuentaContable.value, SELECTOR_TIPO[1])

  const handleShowModal = (e: $TSMigrationFixMe) => {
    e.preventDefault()
    setShowWarningModal(!showWarningModal)
  }

  const onHandleSubmit = (e: $TSMigrationFixMe) => {
    e.preventDefault()
    setShowWarningModal(!showWarningModal)
  }

  const onModalSubmit = (e: $TSMigrationFixMe) => {
    e.preventDefault()
    setShowWarningModal(!showWarningModal)
    handleSubmit()
  }

  return (
    <form onSubmit={onHandleSubmit}>
      <div className='mb-3 p-fluid'>
        <div className='p-field'>
          <div className='mb-3 select-main_content'>
            <div className='input_box'>
              <label>{t("prestamos.form.importLabel")}</label>
              <FormikInputNumber
                id='importe'
                name='importe'
                onBlur={handleBlur}
                minFractionDigits={2}
                handleChange={handleChange}
              />
            </div>

            <div className='text-left col-md-12 col-lg-5 select_container'>
              <label>{t("prestamos.form.commissionLabel")}</label>
              <div className='p-inputgroup'>
                <Dropdown
                  value={values?.comisionImporte.tipoImporte || 1}
                  options={IMPORTE_TIPO_SELECT_OPTIONS}
                  onChange={(e) =>
                    handleSetValue(e.value, "comisionImporte.tipoImporte")
                  }
                />
                <InputNumber
                  id='comisionImporte.valor'
                  name='comisionImporte.valor'
                  onBlur={handleBlur}
                  minFractionDigits={2}
                  onChange={(e) =>
                    handleSetValue(e.value, "comisionImporte.valor")
                  }
                />
              </div>
              <>
                {errors?.comisionImporte?.tipoImporte && (
                  <small className='p-error p-d-block'>
                    {errors.comisionImporte?.tipoImporte}
                  </small>
                )}
              </>
            </div>
          </div>
          <div className='cuentas-contables_select-container !tw-h-auto'>
            <p className='text-left'>
              {t("prestamos.form.accountingAccountLabel")}
            </p>
            <DropdownCuentasContablesConModal
              cuentasContablesOptions={
                prestamo?.tipoPrestamo === PRESTAMOS_TYPE.CONCEDIDO
                  ? cuentasContablesComisionAperturaPrestamoConcedido
                  : cuentasContablesComisionAperturaPrestamoRecibido
              }
              dropdownValue={values?.[SELECTOR_TIPO[1]]}
              onChange={handleSelectCtaContable}
              listaDeCuentasBase={
                prestamo?.tipoPrestamo === PRESTAMOS_TYPE.CONCEDIDO
                  ? cuentasContablesComisionAperturaPrestamoConcedidoComprasBase
                  : cuentasContablesComisionAperturaPrestamoRecibidoComprasBase
              }
              refreshFetchData={
                prestamo?.tipoPrestamo === PRESTAMOS_TYPE.CONCEDIDO
                  ? refresListaDeCuentasComisionAperturaPrestamoConcedido
                  : refresListaDeCuentasComisionAperturaPrestamoRecibido
              }
              withCreateCuenta
            />
          </div>
        </div>
      </div>
      <div>
        <div className='departaments-modal__actions'>
          <p onClick={() => handleOpenModal(null, false)}>
            {t("prestamos.form.cancelButton")}
          </p>
          <CustomButtom
            type='submit'
            className='!tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none tw-cursor-pointer'
            disabled={Boolean(Object.keys(errors)?.length)}
          >
            {t("prestamos.form.createButton")}
          </CustomButtom>
        </div>
      </div>

      <WarningModal
        visible={showWarningModal}
        onHide={handleShowModal}
        size='small'
        buttonLabel='Confirmar'
        title='Confirmar amortización'
        message='Existen cuotas adeudadas.
        Si creas la amortización anticipada se asumirá que se realizó antes de los adeudos.'
        onCancel={handleShowModal}
        onConfirm={(e: $TSMigrationFixMe) => onModalSubmit(e)}
      />
    </form>
  )
}

export default NewAmortizacion
